import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="relative overflow-hidden bg-[#FFF5F0]" data-id="element-9">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-10">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-rose-100 rounded-full blur-3xl opacity-50" data-id="element-11"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 bg-orange-100 rounded-full blur-3xl opacity-50" data-id="element-12"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16 lg:pt-32 lg:pb-24 relative z-10" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-14">
          <Section className="text-center lg:text-left" data-id="element-15">
            <span className="inline-block px-4 py-1.5 rounded-full bg-rose-100 text-rose-800 text-sm font-semibold tracking-wide mb-6" data-id="element-16">
              Para mujeres que dan demasiado
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-stone-900 leading-tight mb-6" data-id="element-17">
              Hay un tipo de hambre que no se siente como hambre.
            </h1>
            <p className="text-xl md:text-2xl text-stone-600 font-serif italic mb-8" data-id="element-18">
              Se siente como{' '}
              <span className="text-rose-600 font-semibold" data-id="element-19">urgencia</span>.
            </p>
            <p className="text-lg text-stone-600 mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-20">
              Como si alguien dentro de ti apretara un botón y de pronto tu día
              se encogiera a una sola idea: "Necesito algo dulce. Necesito algo
              ya."
            </p>

            <div className="flex flex-col items-center lg:items-start gap-3" data-id="element-21">
              <Button onClick={scrollToPricing} className="shadow-xl shadow-rose-200/50 py-4 px-8 h-auto" data-id="element-22">
                <div className="flex flex-col items-center" data-id="element-23">
                  {/* Pricing Row */}
                  <div className="flex items-center gap-3 mb-1 text-rose-100/90 text-sm font-medium" data-id="element-24">
                    <span className="line-through decoration-rose-300/70 decoration-2" data-id="element-25">
                      $17.99
                    </span>
                    <ArrowRightIcon className="w-3 h-3 opacity-60" data-id="element-26" />
                    <span className="text-white font-bold bg-white/20 px-1.5 rounded text-base" data-id="element-27">
                      $6.39
                    </span>
                  </div>

                  {/* Main CTA */}
                  <span className="text-lg font-bold tracking-wide" data-id="element-28">
                    Quiero recuperar mi calma
                  </span>

                  {/* Urgency */}
                  <div className="flex items-center gap-1.5 mt-1.5 text-xs font-medium text-rose-100 animate-pulse" data-id="element-29">
                    <ClockIcon className="w-3 h-3" data-id="element-30" />
                    <span data-id="element-31">Oferta por tiempo limitado</span>
                  </div>
                </div>
              </Button>
              <p className="text-xs text-stone-400 italic" data-id="element-32">
                *Acceso inmediato al contenido digital
              </p>
            </div>
          </Section>

          <Section delay={200} className="relative" data-id="element-33">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-700" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/49euqB3UzyxUzwhZCbsBD2/Imagen_producto_2.png" alt="Mujer leyendo la guía Reset Hormonal en calma" className="w-full h-auto object-cover" data-id="element-35" />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/20 to-transparent" data-id="element-36"></div>
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg max-w-xs hidden md:block animate-bounce-slow" data-id="element-37">
              <p className="text-stone-800 font-medium text-sm" data-id="element-38">
                "No es falta de disciplina.
                <br data-id="element-39" />
                Es un sistema saturado."
              </p>
            </div>
          </Section>
        </div>
      </div>
    </div>;
}